module.exports = __webpack_public_path__ + "static/media/slide3.1608e198.png";